import * as React from "react";

import {
  Button,
  ClickAwayListener,
  Fade,
  FormControl,
  FormControlLabel,
  Paper,
  Radio,
  RadioGroup,
} from "@mui/material";
import Popper from "@mui/material/Popper";
import usePlatform from "@/hooks/usePlatform";
import { SORT_OPTIONS } from "./sortConfig";

export default function Sort(props: { value?: number; onChange: (v: number) => void }) {
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const open = Boolean(anchorEl);
  const id = open ? "sort-popper" : undefined;
  const { isPc } = usePlatform();
  return (
    <div>
      <Button
        className="translate-x-90"
        color="primary"
        aria-describedby={id}
        onClick={(e) => {
          e.stopPropagation();
          handleClick(e);
        }}
        sx={{
          textTransform: "none",
          // fontSize: "15px",
          fontWeight: "bold"
        }}
      >
        {isPc ? "Sort by:" : "Sort"}
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          focusable="false"
          style={{ fill: "currentcolor" }}
        >
          <path d="M4 7l1.41 1.41L8 5.83V13h2V5.83l2.59 2.58L14 7 9 2 4 7zm16 10l-1.41-1.41L16 18.17V11h-2v7.17l-2.59-2.58L10 17l5 5 5-5z" />
        </svg>
      </Button>

      <ClickAwayListener
        onClickAway={() => {
          setAnchorEl(null);
        }}
      >
        <Popper id={id} open={open} anchorEl={anchorEl} placement={"bottom-end"} transition>
          {({ TransitionProps }) => (
            <Fade {...TransitionProps} timeout={350}>
              <Paper className="py-[10px] px-[20px]">
                <FormControl>
                  <RadioGroup
                    aria-labelledby="demo-controlled-radio-buttons-group"
                    name="controlled-radio-buttons-group"
                    value={props.value}
                    onChange={(e) => {
                      props.onChange(parseInt(e.target.value));
                      setAnchorEl(null);
                    }}
                  >
                    {SORT_OPTIONS.map((item) => {
                      return (
                        <FormControlLabel
                          key={item.value}
                          value={item.value}
                          control={<Radio />}
                          label={item.label}
                        />
                      );
                    })}
                  </RadioGroup>
                </FormControl>
              </Paper>
            </Fade>
          )}
        </Popper>
      </ClickAwayListener>
    </div>
  );
}
